export const loseFocus = () => document.querySelector(':focus')?.blur();
